import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FiCalendar,
  FiChevronLeft,
  FiChevronRight,
  FiEye,
  FiHome,
  FiMail,
  FiPlus,
  FiSearch,
  FiUsers,
  FiX,
} from "react-icons/fi";

import { RoutesPaths } from "../Router/constant";
import { getAdmins } from "../Services/userService";
import Skeleton from "../Components/SkeletonLoader";

export default function Adminmanagement() {
  const [adminData, setAdminData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [limit] = useState(10);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const userRole = localStorage.getItem("userRole");
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm.trim());
      setOffset(1);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);
  useEffect(() => {
    fetchAdmins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset, debouncedSearch]);

  const fetchAdmins = async () => {
    try {
      setLoading(true);

      const response = await getAdmins({
        offset,
        limit,
        search: debouncedSearch,
      });
      console.log("Admins API response:", response?.data);
      const responseData = response?.data?.data ?? response?.data;
      let admins = [];

      if (Array.isArray(responseData?.admins)) {
        admins = responseData.admins;
      } else if (Array.isArray(responseData?.records)) {
        admins = responseData.records;
      } else if (Array.isArray(responseData?.data)) {
        admins = responseData.data;
      } else if (Array.isArray(responseData)) {
        admins = responseData;
      }

      const totalCount =
        responseData?.count ??
        responseData?.total ??
        responseData?.totalCount ??
        responseData?.pagination?.total ??
        admins.length;

      setAdminData(admins);
      setCount(Number(totalCount) || 0);
    } catch (error) {
      console.error("Get admins error:", error);

      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.data?.message ||
          "Failed to load admins",
      );

      setAdminData([]);
      setCount(0);
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(count / limit);
  const currentPage = offset;
  const generatePagination = (currentPage, totalPages) => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    if (currentPage <= 3) {
      pages.push(1, 2, 3, "...", totalPages);
    } else if (currentPage >= totalPages - 2) {
      pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, "...", currentPage, "...", totalPages);
    }

    return pages;
  };
  const getAdminName = (admin) => {
    return admin?.fullName || admin?.name || admin?.username || "N/A";
  };
  const handleClearSearch = () => {
    setSearchTerm("");
    setDebouncedSearch("");
    setOffset(1);
  };

  const firstRow = count === 0 ? 0 : (offset - 1) * limit + 1;
  const lastRow = Math.min(offset * limit, count);

  return (
    <div className="container-fluid qd-page">
      {/* Breadcrumb */}
      <nav className="qd-breadcrumb">
        <NavLink to={RoutesPaths.DASHBOARD} aria-label="Dashboard">
          <FiHome />
        </NavLink>
        <FiChevronRight />
        <span className="qd-breadcrumb-current">Admin management</span>
      </nav>

      {/* Header */}
      <div className="qd-card qa-header">
        <div className="qd-panel-title">
          <span className="qa-header-icon">
            <FiUsers />
          </span>
          <div>
            <h1 className="qa-title">Admin details</h1>
            <p className="qd-panel-sub qa-sub">Manage all system administrators and their access.</p>
          </div>
        </div>

        <div className="qd-bookings-tools">
          <label className="qd-search qa-search">
            <FiSearch />
            <input
              type="text"
              placeholder="Search name or email"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button
                type="button"
                className="qa-clear"
                onClick={handleClearSearch}
                aria-label="Clear search"
              >
                <FiX />
              </button>
            )}
          </label>

          {userRole === "admin" && (
            <NavLink to={RoutesPaths.CREATEADMIN} className="qd-btn qd-btn-primary qa-create">
              <FiPlus /> Create new admin
            </NavLink>
          )}
        </div>
      </div>

      {/* Table */}
      <div className="qd-card qd-panel">
        <div className="qd-table-wrap">
          <table className="qd-table qa-table">
            <thead>
              <tr>
                <th className="qa-sno">S.No.</th>
                <th>Name</th>
                <th>Email</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                [...Array(5)].map((_, index) => (
                  <tr key={index}>
                    <td><Skeleton width={30} height={28} /></td>
                    <td><Skeleton width={160} /></td>
                    <td><Skeleton width={220} /></td>
                    <td><Skeleton width={100} /></td>
                    <td><Skeleton width={100} height={36} /></td>
                  </tr>
                ))
              ) : adminData.length === 0 ? (
                <tr>
                  <td colSpan={5} className="qd-empty">
                    {debouncedSearch ? "No admin found for your search" : "No admin found"}
                  </td>
                </tr>
              ) : (
                adminData.map((admin, index) => {
                  const name = getAdminName(admin);
                  return (
                    <tr key={admin?._id || index}>
                      <td className="qa-sno">
                        <span className="qa-sno-badge">{(offset - 1) * limit + index + 1}</span>
                      </td>
                      <td>
                        <span className="qd-customer">
                          <span className="qd-avatar qa-avatar">
                            {name !== "N/A" ? name.trim().charAt(0).toUpperCase() : "?"}
                          </span>
                          {name}
                        </span>
                      </td>
                      <td>
                        <span className="qd-date qa-email">
                          <FiMail />
                          {admin?.email || "N/A"}
                        </span>
                      </td>
                      <td>
                        <span className="qd-date">
                          <FiCalendar />
                          {admin?.createdAt
                            ? new Date(admin.createdAt).toLocaleDateString("en-GB")
                            : "N/A"}
                        </span>
                      </td>
                      <td>
                        <NavLink
                          to={`${RoutesPaths.ADMINDETAILS}/${admin?._id}`}
                          state={{ admin }}
                          className="qd-btn qd-btn-primary qd-btn-sm qa-view-btn"
                        >
                          <FiEye /> View
                        </NavLink>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {!loading && count > 0 && (
          <div className="qd-pagination">
            <span className="qd-muted">
              Showing {firstRow} to {lastRow} of {count} admins
            </span>
            {totalPages > 1 && (
              <div className="qd-pages">
                <button
                  disabled={currentPage <= 1}
                  onClick={() => setOffset(currentPage - 1)}
                  aria-label="Previous"
                >
                  <FiChevronLeft />
                </button>
                {generatePagination(currentPage, totalPages).map((page, index) =>
                  page === "..." ? (
                    <span key={`dots-${index}`} className="qd-ellipsis">...</span>
                  ) : (
                    <button
                      key={page}
                      className={currentPage === page ? "active" : ""}
                      onClick={() => setOffset(page)}
                    >
                      {page}
                    </button>
                  ),
                )}
                <button
                  disabled={currentPage >= totalPages}
                  onClick={() => setOffset(currentPage + 1)}
                  aria-label="Next"
                >
                  <FiChevronRight />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
